import { throwOnError } from './utils';

export type UserTag = {
  id: string;
  user_tag_group: {
    id: string;
    name_en: string;
    name_ja: string;
    name_zh_hans: string;
    name_zh_hant: string;
    name_ko: string;
    max_selections: number;
    is_active: boolean;
  };
  user_tag_group_item: {
    id: string;
    name_en: string;
    name_ja: string;
    name_zh_hans: string;
    name_zh_hant: string;
    name_ko: string;
    is_active: boolean;
    // 所属 subgroup（中間層）。group 直下（未分類）の item は null。
    user_tag_subgroup: {
      id: string;
      name_en: string;
      name_ja: string;
      name_zh_hans: string;
      name_zh_hant: string;
      name_ko: string;
      is_active: boolean;
    } | null;
  };
  created_at: string;
  updated_at: string;
};

type FetchUserTagsResponse = {
  rows: UserTag[];
};

export const fetchUserTags = (userUuid: string, query = '') =>
  fetch(`/api/users/${userUuid}/tags${query ? `?${query}` : ''}`, {
    method: 'GET',
    credentials: 'same-origin',
  }).then(throwOnError<FetchUserTagsResponse>);

export const attachUserTag = (userUuid: string, userTagGroupItemId: string) =>
  fetch(`/api/users/${userUuid}/tags`, {
    method: 'POST',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({
      _csrf_token: (window as any)._csrf_token,
      user_tag_group_item_id: userTagGroupItemId,
    }),
  }).then(throwOnError<UserTag>);

export const detachUserTag = (userUuid: string, tagUuid: string) =>
  fetch(`/api/users/${userUuid}/tags/${tagUuid}`, {
    method: 'DELETE',
    credentials: 'same-origin',
    headers: {
      'content-type': 'application/json',
    },
    body: JSON.stringify({ _csrf_token: (window as any)._csrf_token }),
  }).then(throwOnError);
